// Detects whether a variable value should be treated as a class-style block.
// Example: ".card { color: red; }" is class-like, arrays/objects are excluded.
import { isArrayVariableValue } from "../array-variable";
import { isObjectVariableValue } from "../object-variable";

// Class variables are rule-like values containing `{ ... }` blocks.
export function isClassVariableValue(value: string): boolean {
  // Object-style values must be handled by object-variable logic.
  if (isObjectVariableValue(value)) {
    // Return false for object variables.
    return false;
  }

  // Array-style values must be handled by array-variable logic.
  if (isArrayVariableValue(value)) {
    // Return false for array variables.
    return false;
  }

  // Return true only when value contains a rule block.
  return value.includes("{") && value.includes("}");
}
